import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import InspectionCardImage from '@/presentation/assets/img/Inspection.jpg'
import Calendar from '@/presentation/assets/svg/Calendar.svg'
import Button from '@/presentation/components/Button'
import { inspectionTypeToUI } from '@/presentation/mappers/InspectionTypeMapper'
import { ROUTES } from '@/services/constants/routes'
import useNavigateWithOrderCode from '@/services/hooks/useNavigateWithOrderCode'
import { useInspection } from '@/services/providers/InspectionContext'
import safeParseDate from '@/services/utils/safeParseDate'

interface InspectionCardProps {
  fetched: boolean
  displayDate?: string
}

const InspectionCard: React.FC<InspectionCardProps> = ({
  fetched,
  displayDate
}) => {
  const { t } = useTranslation()

  const navigate = useNavigateWithOrderCode()
  const { orderCode } = useParams()

  const { inspection } = useInspection()

  const handleClick = () => fetched && navigate(ROUTES.ROOMS)

  return (
    <div
      className="mb-6 flex w-full cursor-pointer flex-col rounded-2xl shadow-md"
      onClick={handleClick}
    >
      <img
        className="h-80 rounded-t-2xl border border-b-0 border-gray-300 object-cover object-top"
        src={InspectionCardImage}
      />

      <div className="flex flex-col gap-4 rounded-b-2xl border border-t-0 border-gray-300 p-4">
        <div className="flex flex-col">
          <div className="flex items-start justify-between gap-x-4">
            <div>
              <span className="block w-full text-xl font-bold text-gray-600">
                {inspectionTypeToUI(inspection?.inspectionType)}
              </span>

              {orderCode && (
                <span className="mb-4 block text-gray-600">{orderCode}</span>
              )}
            </div>

            <div className="flex items-center gap-x-2">
              <img className="hidden sm:block" src={Calendar} alt="Calendar" />

              {displayDate && (
                <span className="text-gray-600">
                  {safeParseDate(displayDate).toLocaleDateString('pt-BR')}
                </span>
              )}
            </div>
          </div>

          {inspection?.inspectionType !== 'predial' && (
            <span className="text-gray-600">
              {t(
                'CHECK_HERE_YOUR_DIGITAL_INSPECTION',
                'Confira aqui sua vistoria digital e'
              )}{' '}
              <span className="font-bold text-primary">
                {t('POINT_OUT_CONTESTATIONS', 'aponte contestações.')}
              </span>
            </span>
          )}
        </div>

        <Button className="py-4 text-lg">
          {t('ACCESS_DIGITAL_INSPECTION', 'Acessar vistoria digital')}
        </Button>
      </div>
    </div>
  )
}

export default InspectionCard
